<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1" id="ch00_fm02_title"><a id="page_iii"></a>Liberty Tree</h1>
<p class="subtitle"><em>Ordinary People and the<br/>American Revolution</em></p>
<p class="author"><em>Alfred F. Young</em></p>
<p class="author"><span class="small">CONSULTING EDITOR, HARVEY J. KAYE</span></p>
<p class="publisher"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm02_title.vue?4a2fa5e8